import { LegalLayout } from "./layout"

export function PrivacyPage() {
  return (
    <LegalLayout title="Gizlilik politikası">
      <p>Hirefy, kullanıcı verilerini Supabase EU bölgesinde, RLS ile izole şekilde saklar.</p>
    </LegalLayout>
  )
}
